import { ServiceGlobal } from './service.global';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { API } from '../../config/api';

const CACHE_MAX_AGE_MILLISECONDS = 5 * 60 * 1000;
let cachedData: Promise<any> | null = null;
let cachedDataDate: Date | null = null;
function getCachedData(): Promise<any> | null {
    if (!cachedData) {
        return cachedData;
    }
    return cachedData.then((data) => {
        return JSON.parse(JSON.stringify(data));
    })
}

@Injectable()
export class TeacherQuestionnaireQuestionService extends ServiceGlobal {

    name_alpha: any = 'teacher_questionnaire_question_id';
    api_find_one: any = 'teacher_questionnaire_questions';
    api_find_all: any = 'teacher_questionnaire_questions';
    api_delete: any = 'teacher_questionnaire_questions';
    loading: any = false;
    primary_key: any = 'teacher_questionnaire_question_id';
    tableName() { return 'teacher_questionnaire_questions'; }

    teacher_questionnaire_question_id: string;
    teacher_questionnaire_template: string;
    text_en: string;
    text_zh: string;
    sequence: string;

}



// WEBPACK FOOTER //
// ./src/app/common/services/teacher-questionnaire-question.service.ts